import React from 'react';
import List from 'pages/Orders/List';

const CompletedList = ({ ...props }) => (
  <List
    url="orders?order_status=complete"
    title="Completed Jobs"
    showCompletedAt={true}
    canAssign={false}
    showOrderStatus={false}
    canManage={!props.readOnly}
    // hideByDefault={true}
    canView={true}
    showCreatedAt={false}
    {...props}
  />
);

export default CompletedList;



// WEBPACK FOOTER //
// ./src/pages/Orders/CompletedList.jsx